import React from 'react';

const AboutUs = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div>539 W. Commerce St <br/>#5657 Dallas,<br/> TX 75208</div>
      
    </div>
  );
};

export default AboutUs;
